function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { cmsActions } from '../../reducers/cms.reducer';
import PopupsTable from './PopupsTable.react';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import SubHeader from '../header/SubHeader.react';

// TODO :: Stop if app / type is not in constants
var Pages = function Pages(_ref) {
  var popupsAction = _ref.popupsAction;
  var _useParams = useParams(),
    app = _useParams.app,
    itemID = _useParams.itemID;
  var cmsPopups = useSelector(function (s) {
    return s.cms.popups || {};
  });
  var cmsNavigation = useSelector(function (s) {
    return s.cms.navigation || {};
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    popupArr = _useState2[0],
    setPopupArr = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    navItem = _useState4[0],
    setNavItem = _useState4[1];
  useEffect(function () {
    popupsAction({});
  }, []);
  useEffect(function () {
    var arr = [];
    Object.values(cmsPopups).forEach(function (x) {
      if (itemID) {
        var _cmsNavigation$itemID;
        if (x._id === ((_cmsNavigation$itemID = cmsNavigation[itemID]) === null || _cmsNavigation$itemID === void 0 ? void 0 : _cmsNavigation$itemID.popup)) arr.push(x);
      } else arr.push(x);
    });
    setPopupArr(arr);
  }, [cmsPopups, app, itemID, cmsNavigation]);
  useEffect(function () {
    if (!itemID || !cmsNavigation[itemID]) setNavItem(null);else setNavItem(cmsNavigation[itemID]);
  }, [itemID]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubHeader, {
    route: "popups"
  }), /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, itemID && /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(NavLink, {
    className: "page__content--back",
    to: "/".concat(app, "/popups")
  }, "View All")), !itemID && /*#__PURE__*/React.createElement(PopupsTable, {
    popupArr: popupArr,
    app: app
  }), itemID && (navItem === null || navItem === void 0 ? void 0 : navItem.popup) && /*#__PURE__*/React.createElement(PopupsTable, {
    popupArr: popupArr,
    app: app
  }), itemID && !(navItem !== null && navItem !== void 0 && navItem.popup) && /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "No Popups"
  }))))));
};
var mdtp = {
  popupsAction: cmsActions.popups
};
export default connect(null, mdtp)(Pages);